module.exports = "/img/car-gallery-center.456ec98d.png";